'use client'

import { useModals } from '@/lib/hooks'
import { useAppSelector } from '@/lib/hooks/use-redux'
import type React from 'react'
import { use } from 'react'

import { AddCartItemSerial } from '@/components/forms/add-cart-item-serial'
import { RefContext, type Refs } from '@/components/providers/ref-provider'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

interface AddCartItemSerialModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const AddCartItemSerialModal = ({
  open,
}: AddCartItemSerialModalProps) => {
  const { closeModal } = useModals()
  const { product } = useAppSelector((state) => state.selectedProduct)
  const { barcodeInputRef } = use(RefContext) as Refs

  return (
    <Dialog open={open} onOpenChange={() => barcodeInputRef.current?.focus()}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('ADD_CART_ITEM_SERIAL')}
        size="lg"
        className="min-h-[200px]"
      >
        <VisuallyHidden>
          <DialogTitle>Add Cart Item Serial</DialogTitle>
        </VisuallyHidden>
        {product && <AddCartItemSerial product={product} />}
      </DialogContent>
    </Dialog>
  )
}
